const state = () => ({
  isValid: false,
  treatmentCenter: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  treatmentCenter(state) {
    return state.treatmentCenter;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateTreatmentCenter(state, payload) {
    state.treatmentCenter = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  updateTreatmentCenter({ commit }, payload) {
    commit('updateTreatmentCenter', payload);
  }
};

export const msCenter = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
